import { makeStyles, Theme } from '@material-ui/core/styles';

export const useNextBestActionCardStyles = makeStyles((theme: Theme) => ({
    card: { backgroundColor: 'transparent' },
    header: { borderBottom: `1px solid ${theme.palette.divider}` },
    meta: {
        display: 'grid',
        gap: theme.spacing(1),
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        marginTop: theme.spacing(1.5),
    },
    metaItem: {
        backgroundColor: theme.palette.action.hover,
        borderRadius: theme.shape.borderRadius * 2,
        padding: theme.spacing(1, 1.25),
    },
    evidence: {
        borderTop: `1px solid ${theme.palette.divider}`,
        marginTop: theme.spacing(1.5),
    },
    actions: { flexWrap: 'wrap', gap: theme.spacing(1), padding: 0 },
    groupLabel: { flexBasis: '100%' },
    option: {
        backgroundColor: 'var(--action-color)',
        color: theme.palette.common.white,
        '&:hover': { backgroundColor: 'var(--action-hover-color)' },
    },
    alternative: {
        backgroundColor: 'var(--action-soft-color)',
        borderColor: 'var(--action-color)',
        color: 'var(--action-color)',
        '&:hover': {
            backgroundColor: 'var(--action-color)',
            color: theme.palette.common.white,
        },
    },
}));
